import Metrics from "./Metrics";
import AppStyle from "./AppStyle";
import * as Icons from "./Icons";
import Colors, { ColorLists } from "./Colors";

export {
	Colors, ColorLists,
	Metrics, AppStyle, 
	Icons,
};


// WEBPACK FOOTER //
// ./src/theme/index.js